import AmountFormat from './AmountFormat';


export default AmountFormat;
export {
	AmountFormat
};